import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

customerSelectorToolbarStyles.narrowHidden = {
    above: "sm",
    css: css`
        position: absolute;
        right: 15px;
        @media only screen and (max-width: 769px) {
            top: 5px;
        }
        @media only screen and (max-width: 415px) {
            top: 35px;
        }
    `,
};

customerSelectorToolbarStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 10px;
            > button {
                &:hover {
                    background: white;
                    border-color: white;
                }
            }
        `,
    },
};
